import React, {Component} from 'react';

import queryString from 'query-string';

import Admin from './Admin.js';
import Branch from './Branch.js';

import {createBrowserHistory} from 'history';
const history = createBrowserHistory();

class ContractMngr extends Component {

	constructor(props) {
		super(props);

		const query =  queryString.parse(this.props.location.search);
		const type = query.type || "list";
		this.state= {
			type : type,
			query : query
		};

	}

	render() {
		const {type, query} = this.state;
		const userType = localStorage.getItem("login_user_type") || 'admin';
		const branchId = userType === 'branch' ? localStorage.getItem("login_branch_id") || 0 : 0;
		
		if (userType === 'branch') {
			return <Branch history={this.props.history} query={query} branch_id={branchId}/>
		} else {
			return <Admin history={this.props.history} query={query}/>
		}
	}
}


export default ContractMngr;